import React, { useState } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './QRForm.css';

function CnicQR() {
  const [formData, setFormData] = useState({
    class_id: '',
    course_id: '',
    course_date: new Date(),
    facilitator_name: ''
  });
  const [qrCode, setQrCode] = useState(null);
  const [generatedUrl, setGeneratedUrl] = useState('');
  const [error, setError] = useState('');

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleDateChange = (date) => {
    setFormData({
      ...formData,
      course_date: date
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    try {
      // Format date as YYYY-MM-DD
      const formattedDate = formData.course_date.toISOString().split('T')[0];

      // Base URL
      const baseUrl = "https://forms.osi.apps.mil/Pages/ResponsePage.aspx?id=AD4z43fIh0u2rUXpQt4XUBkcK5o1LX5Kvxcg9HxdbtxUOTI1M0xTVU01T1BTTlNXTzZPTTZYQzRRUS4u";
      
      // URL encode the facilitator name
      const facilitatorEncoded = encodeURIComponent(formData.facilitator_name);
      
      // Add quotes around the date and URL encode
      const dateWithQuotes = `"${formattedDate}"`;
      const dateEncoded = encodeURIComponent(dateWithQuotes);
      
      // Build the full URL with parameters
      const fullUrl = `${baseUrl}&rb7c8acdfb2d344c999c57188142e91aa=${formData.class_id}&r25abe8919e3b40de8204984582cf866e=${formData.course_id}&r9409503692e64bb3a21cd58c0d54fb75=${dateEncoded}&r1255bf61401a4111944e722d420454f7=${facilitatorEncoded}`;
      
      setQrCode(fullUrl);
      setGeneratedUrl(fullUrl);
    } catch (err) {
      setError('Failed to generate QR code. Please check your inputs and try again.');
      console.error(err);
    }
  };

  const handleDownload = () => {
    const canvas = document.getElementById('cnic-qr-canvas');
    const pngUrl = canvas
      .toDataURL('image/png')
      .replace('image/png', 'image/octet-stream');
    const downloadLink = document.createElement('a');
    downloadLink.href = pngUrl;
    downloadLink.download = `cnic-qr-${formData.class_id}.png`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  const handleCopyUrl = () => {
    navigator.clipboard.writeText(generatedUrl);
    alert('URL copied to clipboard!');
  };

  return (
    <div className="qr-form">
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="class_id">Class ID Number:</label>
          <input
            type="text"
            id="class_id"
            name="class_id"
            value={formData.class_id}
            onChange={handleInputChange}
            placeholder="e.g., ABCD"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="course_id">Course ID Number:</label>
          <input
            type="text"
            id="course_id"
            name="course_id"
            value={formData.course_id}
            onChange={handleInputChange}
            placeholder="e.g., 123-123-1234"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="course_date">Date of Class:</label>
          <DatePicker
            selected={formData.course_date}
            onChange={handleDateChange}
            dateFormat="yyyy-MM-dd"
            className="date-picker"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="facilitator_name">Facilitator Name:</label>
          <input
            type="text"
            id="facilitator_name"
            name="facilitator_name"
            value={formData.facilitator_name}
            onChange={handleInputChange}
            placeholder="e.g., Matthew Frank"
            required
          />
        </div>

        <button type="submit" className="submit-button">
          Generate QR Code
        </button>
      </form>

      {error && <div className="error-message">{error}</div>}

      {qrCode && (
        <div className="qr-result">
          <h3>Your QR Code:</h3>
          <div style={{ display: 'none' }}>
            <QRCodeCanvas id="cnic-qr-canvas" value={qrCode} size={300} level="L" />
          </div>
          <div className="qr-display">
            <QRCodeCanvas value={qrCode} size={300} level="L" />
          </div>
          
          <div className="url-display">
            <strong>Generated URL:</strong>
            <div className="url-text">{generatedUrl}</div>
          </div>

          <div className="action-buttons">
            <button onClick={handleDownload} className="action-button download">
              Download QR Code
            </button>
            <button onClick={handleCopyUrl} className="action-button copy">
              Copy URL
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default CnicQR;